// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "tech.okto",
    name: "Okto",
    homepage: "https://okto.tech/",
    image_id: "154c69b7-9bb1-4010-5b4c-6b37eeda8900",
    app: {
        browser: "https://okto.go.link/?adj_t=j39b9kp&adj_fallback=https%3A%2F%2Fokto.tech&adj_redirect_macos=https%3A%2F%2Fokto.tech",
        ios: "https://apps.apple.com/in/app/okto-wallet/id6450688229",
        android: "https://play.google.com/store/apps/details?id=com.coindcx.okto&hl=en_IN&gl=US",
        mac: "",
        windows: null,
        linux: null,
        chrome: "https://okto.tech/",
        firefox: null,
        safari: "https://okto.tech/",
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "okto://",
        universal: "https://okto.go.link/?adj_t=j39b9kp&adj_fallback=https%3A%2F%2Fokto.tech&adj_redirect_macos=https%3A%2F%2Fokto.tech",
    },
    desktop: {
        native: null,
        universal: "https://okto.tech/",
    },
};
//# sourceMappingURL=index.js.map